import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

function Sanitise({ tag, string, className, options, required = true }) {
  const allowedTags = ['b', 'i', 'em', 'strong', 'a', 'u', 'ul', 'li', 'ol', 'p', 'h2', 'h3', 'h4', 'br'];
  const allowedAttributes = ['href', 'class', 'id', 'target', 'title'];

  const Element = tag || 'div';

  if (required && string === '') {
    return null;
  }
  return (
    <Element
      className={className}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(string, { ALLOWED_TAGS: allowedTags, ALLOWED_ATTR: allowedAttributes, ...options })
      }}
    />
  );
}

Sanitise.propTypes = {
  /**
   * The HTMl tag
   */
  tag: PropTypes.string,
  /**
   * The string
   */
  string: PropTypes.string,
  /**
   * The classes
   */
  className: PropTypes.string,
  /**
   * The options
   */
  options: PropTypes.object,
  /**
   * The required flag
   */
  required: PropTypes.bool
};

export default Sanitise;
